import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { ServiceResponse } from '../model/service'

import { get, post, put, _delete } from './abstract.service'

class ServiceProvider {
  httpConfig: AxiosRequestConfig = {}
  http: AxiosInstance = axios.create(this.httpConfig)
  coreApiHttpConfig: AxiosRequestConfig = {}
  coreApiHttp: AxiosInstance = axios.create(this.coreApiHttpConfig)

  setApiPath(value: string) {
    this.httpConfig.baseURL = value
    this.recreateHttp()
  }

  setCoreApiPath(value: string) {
    this.coreApiHttpConfig.baseURL = value
    this.recreateHttp('coreApi')
  }

  recreateHttp(key: 'default' | 'coreApi' = 'default') {
    switch(key) {
      case 'default': this.http = axios.create(this.httpConfig); break
      case 'coreApi': this.coreApiHttp = axios.create(this.coreApiHttpConfig); break
    }
  }

  get = get
  post = post
  put = put
  delete = _delete
}

export function extractData <T> (response: ServiceResponse<T>): T {
  // @ts-ignore
  return response.data.data || response.data
}

export default new ServiceProvider()
